export const SINGLE_DOOR = 'front door:single';
export const DOUBLE_DOOR = 'front door:double';

export const SINGLE_DOOR_GARAGE = 'garage:one-car';
export const DOUBLE_DOOR_GARAGE = 'garage:two-car';


export const HOME_ITEMS_GARAGE = [
    {
        name: 'House 1',
        imgPath: require('../garage_house1.jpg'),
        class_ids: [2],
        coordinates: [
            [[333, 836], [886, 836], [886, 1111], [333, 1111]]
        ],
        classIDs: [2],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["garage:two-car"],
                coordinates: [
                    [[333, 836], [886, 836], [886, 1111], [333, 1111]]
                ],
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },
    {
        name: 'House 2',
        imgPath: require('../garage_house2.jpg'),
        class_ids: [1],
        coordinates: [
            [[789, 882], [1112, 882], [1112, 1145], [789, 1145]],
            [[428, 881], [744, 881], [744, 1143], [428, 1143]]
        ],
        classIDs: [1, 1],
        canvasDrawData: [
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[789, 882], [1112, 882], [1112, 1145], [789, 1145]]
                ]
            },
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[428, 881], [744, 881], [744, 1143], [428, 1143]]
                ]
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },
    {
        name: 'House 3',
        imgPath: require('../garage_house3.jpg'),
        class_ids: [1],
        coordinates: [
            [[1188, 919], [1548, 919], [1548, 1206], [1188, 1206]],
            [[762, 919], [1131, 919], [1131, 1211], [762, 1211]]
        ],
        classIDs: [1, 1],
        canvasDrawData: [
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[1188, 919], [1548, 919], [1548, 1206], [1188, 1206]]
                ]
            },
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[762, 919], [1131, 919], [1131, 1211], [762, 1211]]
                ]
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },
    {
        name: 'House 4',
        imgPath: require('../garage_house4.jpg'),
        class_ids: [2],
        coordinates: [
            [[477, 870], [1184, 870], [1184, 1170], [477, 1170]]
        ],
        classIDs: [2, 2],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["garage:two-car"],
                coordinates: [
                    [[477, 870], [1184, 870], [1184, 1170], [477, 1170]]
                ],
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },
   
    {
        name: 'House 5',
        imgPath: require('../garage_house5.jpg'),
        class_ids: [1],
        coordinates: [
            [
                [182, 294], [193, 283], [316, 283], [327, 294], [327, 410], [182, 410]
            ],
            [
                [365, 294], [377, 282], [501, 282], [513, 294], [513, 410], [365, 410]
            ]
        ],
        classIDs: [1, 1],
        shapeType: 1,
        canvasDrawData: [
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[578, 839], [613, 804], [1018, 804], [1053, 839], [1053, 1168], [578, 1168]]
                ]
            },
            {
                classId: 1,
                labels: ["garage:one-car"],
                coordinates: [
                    [[1172, 837], [1210, 799], [1603, 799], [1641, 837], [1641, 1165], [1172, 1165]]
                ]
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },
    
];

export const HOME_ITEMS_FRONT = [
    {
        name: 'House 1',
        imgPath: require('../frontdoor_house1.jpeg'),
        class_ids: [1],
        coordinates: [
            [[957, 555], [1077, 555], [1077, 819], [957, 819]]
        ],
        classIDs: [1],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["front door:single"],
                coordinates: [
                    [[957, 555], [1077, 555], [1077, 819], [957, 819]]
                ],
            }
        ],
        dimensions:{ x:2048, y:1365 }
    },  
    {
        name: 'House 2',
        imgPath: require('../frontdoor_house2.jpeg'),
        class_ids: [2],
        coordinates: [
            [[1087, 802], [1198, 802], [1198, 1070], [1087, 1070]]
        ],
        classIDs: [2],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["front door:single"],
                coordinates: [
                    [[1087, 802], [1198, 802], [1198, 1070], [1087, 1070]]
                ],
            }
        ],
        dimensions:{ x:2048, y:1328 }
    },
    {
        name: 'House 3',
        imgPath: require('../frontdoor_house3.jpeg'),
        class_ids: [2],
        coordinates: [
            [
                [817, 842], [1006, 842], [1006, 1064], [817, 1064]
            ]
        ],
        classIDs: [2],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["front door:double"],
                coordinates: [
                    [
                        [817, 842], [1006, 842], [1006, 1064], [817, 1064]
                    ]
                ],
            }
        ],
        dimensions:{ x:2048, y:1366 }
    },
    {
        name: 'House 4',
        imgPath: require('../frontdoor_house4.jpeg'),
        class_ids: [2],
        coordinates: [
            [
                [959, 928], [1088, 928], [1088, 1238], [959, 1238]
            ]
        ],
        classIDs: [2],
        canvasDrawData: [
            {
                classId: 2,
                labels: ["front door:single"],
                coordinates: [
                    [
                        [959, 928], [1088, 928], [1088, 1238], [959, 1238]
                    ]
                ],
            }
        ],
        dimensions:{ x:2048, y:1451 }
    }
];


export const CLASS_ID_MAPPER = {
    1: 'one_car_garage',
    2: 'two_car_garage',
    3: 'front_door'
};



export const SAMPLE_CATALOG = {
        "leadingText": "All about",
        "slides": [
          {
            "introline": "dogs",
            "id": "dogs",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Dogs",
              "copy": "Dog ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "elephants",
            "id": "elephants",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Elephants",
              "copy": "Elephant ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "bears",
            "id": "bears",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Bears",
              "copy": "Bears ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "lizards",
            "id": "lizards",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Lizards",
              "copy": "Lizards ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "snakes",
            "id": "snakes",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Snakes",
              "copy": "Snakes ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "cats",
            "id": "cats",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Cats",
              "copy": "Cats ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "giraffes",
            "id": "giraffes",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Giraffes",
              "copy": "Giraffes ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "owls",
            "id": "owls",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=Owls",
              "copy": "Owls ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          },
          {
            "introline": "horses",
            "id": "horses",
            "content": {
              "image": "https://via.placeholder.com/400x200?text=horses",
              "copy": "Horses ipsum dolor sit amet, consectetur adipiscing elit. Morbi accumsan est ornare, ultricies erat a, dapibus lectus."
            }
          }
        ]
      }
    